import EventEmitter from "eventemitter3";

export const enum EmitterEvents {
  IN_A_COMMUNITY = "inACommunity",
  EASTER_EGG_MODAL = "easterEggModal",
  REWARD_INTERACTION_ONBOARDING = "rewardInteractionOnboarding",
  OPEN_CREATION_STUDIO_MODAL = "openCreationStudioModal",
  BOTTOM_SHEET_DISPLAY = "bottom_sheet_display",
  GO_TO_PROFILE = "GO_TO_PROFILE",
  UNSTAKE = "UNSTAKE",
  ADS_REWARDED = "ADS_REWARDED",
  CONTEST_POINTS_EARNED = "CONTEST_POINTS_EARNED",
}
const emitter = new EventEmitter();

export default emitter;
